export default defineNuxtRouteMiddleware((to, from) => {
  const nuxtApp = useNuxtApp();
  const auth = useAuthStore();

  if (
    auth.logged &&
    auth.user.profile &&
    auth.user.profile.onboarding_init === false &&
    auth.user.profile.onboarding_complete === false &&
    auth.user.profile.onboarding_skip === false
  ) {
    const userLocale = auth?.user?.preferred_language || 'en';
    const targetRoute = userLocale === 'en' ? '/onboarding' : `/${userLocale}/onboarding`;

    return nuxtApp.runWithContext(() => {
      return navigateTo(targetRoute);
    });
  }
});
